import * as React from 'react';
import { Outlet } from 'react-router-dom';

import { Layout as DashboardLayout } from '@/components/dashboard/layout/layout';
import { RootRedirect } from '@/components/validate/RootRedirect';

export const route = {
  path: '/',
  element: (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
  children: [
    // {
    //   index: true,
    //   lazy: async () => {
    //     const { Page } = await import('@/pages/dashboard/home');
    //     return { Component: Page };
    //   },
    // },
    // {
    //     index: true,
    //     lazy: async () => {
    //       const { Page } = await import('@/components/dashboard/validate/ValidateViewParams');
    //       return { Component: Page };
    //     },
    //   },
    { index: true, element: <RootRedirect /> },
    {
        path: 'alerts',
        lazy: async () => {
          const { Page } = await import('@/pages/dashboard/alerts');
          return { Component: Page };
        },
    },
    {
        path: 'historian',
        lazy: async () => {
          const { Page } = await import('@/pages/dashboard/historian');
          return { Component: Page };
        },
    },
  ],
};
